/*
 *==================================================
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2020
 *
 *==================================================
 */
import styled from "styled-components";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";
import Button from "./button";

const BackButton = styled(({ ...props }) => (
  <Button {...props} variant="text">
    <KeyboardBackspaceIcon />
    {props.label}
  </Button>
))`
  ${({ theme }) => `
    color: ${theme.palette.primary.main};
  `}
`;

export default BackButton;
